import { devtools, persist } from 'zustand/middleware';

import { create } from '@app/store/zustand/helpers/create';

import { type UserType } from './types';

interface UserState {
    isLoading: boolean;
    type?: UserType;
}
interface UserStateStore extends UserState {
    setUserType: (type: UserType) => void;
    setIsLoading: (isLoading: boolean) => void;
}

const initialState: UserState = {
    isLoading: false,
    type: undefined,
};

export const useUser = create<UserStateStore>()(
    devtools(
        persist(
            (set) => ({
                ...initialState,
                setUserType: (type: UserType) => set({ type }),
                setIsLoading: (isLoading: boolean) => set({ isLoading }),
            }),
            { name: 'user-storage' },
        ),
    ),
);
